export { MaCollapseArrowModule } from './src/collapse-arrow/collapse-arrow.module';
export { MaDragAndScrollDirective } from './src/drag-and-scroll/directive/drag-and-scroll/drag-and-scroll';
export { MaDragAndScrollModule } from './src/drag-and-scroll/module';
export { MaDropdownMenuModule } from './src/dropdown-menu/module';
export { MaErrorModule } from './src/error/module';
export { MaFileUploadButtonModule } from './src/file-upload-button/module';
export { MaInputNumberModule } from './src/input-number/module';
export { MaKeyboardModule } from './src/keyboard/module';
export { MaKeyboardControllerModule } from './src/keyboard-controller/keyboard-controller.module';
export { KeyboardTargetInput } from './src/keyboard-controller/directives/keyboard-target.directive';
export { EMaKeyboardSkin, EMaKeyboardType } from './src/keyboard/type/type';
export { MaMsToHMSModule } from './src/ms-to-hms/module';
export { MaMsToWordsModule } from './src/ms-to-words/module';
export { MaMsToShortWordsModule } from './src/ms-to-short-words/module';
export { retryDelay, resizeObserver } from './src/rxjs';
export { ERoles, MaAuthService, TeachersRoles } from './src/service/auth';
export { MaLocalStorageService } from './src/service/local-storage';
export { MaClickStopPropagationModule } from './src/stop-propagation/module';
export { toolsCursors, whiteboardToolbarIcons } from './src/whiteboard/icons/icons';
export { MaWhiteboardSharedModule } from './src/whiteboard/module';
export { MaAvatarModule } from './src/avatar/module';
export { MaProgressBarModule } from './src/progress-bar/module';
export { MaScrollListModule } from './src/scroll-list/module';
export { MaDraggableContainerModule } from './src/draggable-container/module';
export { MaDateModule } from './src/date/module';
export { diffDays } from './src/date/pipe/nice-date/nice-date';
export { MaInfiniteScrollListModule } from './src/infinite-scroll-list/module';
export { MaErrorPagesService } from './src/service/error-pages';
export { MaSubjectSelectModule } from './src/subject-select/subject-select.module';
export { EsIdGetterService } from './src/service/esid-getter-service';

export { MaPartnerCursor, MaCursorPosition, MaPartnerCursorWithViewport } from './src/whiteboard/interface';
export { MaRemoteOutsideCursorComponent } from './src/whiteboard/remote-outside-cursor/remote-outside-cursor.component';

// комопонент для вставки в директиву libs/shared/~/SkyUiTooltipDirective
export { MaTooltipModule } from './src/ui/ma-tooltip/ma-tooltip.module';
export { MaTooltipComponent } from './src/ui/ma-tooltip/component/ma-tooltip/ma-tooltip.component';
export {
  compareDates,
  getTrueLineHeight,
  findClosestInnerTextElement,
  generateRandomIntFromRange,
  getRandomElementFromArray,
  mapInputChangesToState,
  parseRoomHashFromUrl,
} from './src/helpers/helpers';

export {
  EMaSpecialChars,
  IMaJuniorKeyboardKey,
  IMaKeyboard,
  TMaKeyboardKeysGroup,
  IMaKLPKeyboardKey,
} from './src/keyboard/type/type';
export { MaKeyboardService } from './src/keyboard/service/keyboard';

export { MaScoreModule } from './src/score/score.module';
export { MaScoreComponent } from './src/score/components/score/score';
export { prepareScore } from './src/score/helper';

export { RoutesConfig, MA_403_REASON_QUERY_PARAM } from './src/service/shared.consts';
export type { Ma403Reason } from './src/service/shared.consts';
export { MaToolsGroupModule } from './src/ui/tools-group/tools-group.module';
export { DropFilesZoneModule } from './src/drop-file-zone/module';

export {
  MA_CDN_URL,
  MA_WORD_CARD_DEFAULT_DESKTOP_STATIC_POSITION,
  MA_WORD_CARD_PARTICIPANTS_EXPANDED_STATIC_POSITION,
  MA_WORD_CARD_PARTICIPANTS_COLLAPSED_STATIC_POSITION,
  MA_WORD_CARD_FULL_SCREEN_TOP_STATIC_POSITION,
  MA_WORD_CARD_DEFAULT_TOP_STATIC_POSITION,
} from './src/const';
export { MaMutedStreamModule, MaMutedStreamPipe } from './src/muted-stream';

export { MaStoreNormalizedList } from './src/store-normilized-list/types';

export {
  normalizedListToArray,
  normalizedListFromArray,
  normalizedListAppend,
  normalizedListUpdateItem,
  normalizedListRemoveItem,
} from './src/store-normilized-list/helpers';

export { LevelsTranslationService } from './src/levels/levels-translation.service';

export { MaCancelableSuccessNotificationComponent } from './src/cancelable-success-notification/cancelable-success-notification.component';
export {
  NotificationCloseData,
  CancelableSuccessNotificationComponentParams,
} from './src/cancelable-success-notification/interface';

export { MaSessionDurationService } from './src/service/session-duration.service';
